import React, { useState, useEffect } from "react";
import CrossAttachmentAssessment from "../../../../Assesment/pages/Create_Assessment/Attachment/CrossAttachmentAssessment";
import "./uploadQuestion.css";
import AttachmentDefault from "../../Create_Assessment/Create_Question/Create_Q_Type/AttachmentDefault";
import { Paper, Box, Typography, Stack, Divider } from "@mui/material";

const UploadQuestion = ({
  response,
  questionNumber,
  setResponseAnswers,
  studentResults,
}) => {
  const [inputValue, setInputValue] = useState({
    remark: "",
    score: "",
  });

  const { remark, score } = inputValue;
  const matchResultWithResponse = () => {
    let result = studentResults.find(
      (result) => result?.question_response?.id === response?.id
    );
    return result;
  };

  useEffect(() => {
    !studentResults?.length > 0 &&
      setInputValue({
        remark: response?.result?.remark,
        score: response?.result?.score ? response?.result?.score : "",
      });
    const resultInitialization = () => {
      setResponseAnswers((prevState) =>
        prevState.map((responseData) =>
          responseData.id === response.id
            ? {
                ...responseData,
                result: {
                  ...responseData.result,
                  questionResponse: response.id,
                  correctScore: response?.question?.correct_score,
                },
              }
            : responseData
        )
      );
    };
    (!response?.result?.questionResponse || !response?.result?.correctScore) &&
      !studentResults?.length > 0 &&
      resultInitialization();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const handleSubmitRemark = (e) => {
    setResponseAnswers((prevState) =>
      prevState.map((responseData) =>
        responseData.id === response.id
          ? {
              ...responseData,
              result: { ...responseData.result, remark: e.target.value },
            }
          : responseData
      )
    );
  };

  const handleSubmitScore = (e) => {
    setResponseAnswers((prevState) =>
      prevState.map((responseData) =>
        responseData.id === response.id
          ? {
              ...responseData,
              result: { ...responseData.result, score: e.target.value },
            }
          : responseData
      )
    );
  };

  return (
    <Paper
      elevation={1}
      sx={{
        mt: 3,
        p: 3,
        borderRadius: 2,
        border: "1px solid #e5e7eb",
        backgroundColor: "#ffffff",
      }}
    >
      {/* QUESTION */}
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Typography fontWeight={700} color="#001A6E">
          Q{questionNumber + 1}.
        </Typography>

        <Typography fontSize={18} color="#001A6E">
          {response?.question?.title?.split("\n").map((line, index) => (
            <span key={index}>
              {index !== 0 && <br />}
              {line}
            </span>
          ))}
          {response?.question?.is_mandatory === "true" && (
            <span style={{ color: "brown", marginLeft: 6 }}>*mandatory</span>
          )}
        </Typography>
      </Stack>

      {/* QUESTION ATTACHMENTS */}
      {response?.question?.attachments?.length > 0 && (
        <Stack direction="row" spacing={2} mt={2} ml={4}>
          {response.question.attachments.map((file, index) => (
            <AttachmentDefault
              key={index}
              attach={file}
              fileSize={response?.question?.attachments_sizeKb[index]}
            />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 3 }} />

      {/* STUDENT ANSWER */}
      <Typography fontWeight={600} color="#001A6E" mb={1}>
        Student Answer
      </Typography>

      <Box
        sx={{
          p: 2,
          borderRadius: 1.5,
          backgroundColor: "#f9fafb",
          border: "1px solid #e5e7eb",
          minHeight: "60px",
        }}
      >
        <Typography>
          {response?.descriptive_answer?.trim()
            ? response.descriptive_answer
            : "No Answer"}
        </Typography>
      </Box>

      {/* STUDENT ATTACHMENTS */}
      {response?.attachments?.length > 0 && (
        <Stack direction="row" spacing={2} mt={2}>
          {response.attachments.map((file, index) => (
            <AttachmentDefault
              key={index}
              attach={file}
              fileSize={response?.attachments_sizeKb[index]}
            />
          ))}
        </Stack>
      )}

      <Divider sx={{ my: 3 }} />

      {/* TEACHER COMMENT */}
      <Typography fontWeight={600} mb={1}>
        Teacher Comment
      </Typography>

      <textarea
        className="remark_textfield_box_hw"
        maxLength={250}
        readOnly={studentResults?.length > 0}
        value={
          studentResults?.length > 0
            ? matchResultWithResponse()?.comment
            : remark
        }
        onChange={(e) =>
          setInputValue((prev) => ({ ...prev, remark: e.target.value }))
        }
        onBlur={handleSubmitRemark}
      />

      {/* MARKS */}
      <Stack direction="row" alignItems="center" spacing={2} mt={2}>
        <Typography>
          Allot marks out of {response?.question?.correct_score}
        </Typography>

        <input
          className="score_box_hw px-2"
          type="text"
          readOnly={studentResults?.length > 0}
          value={
            studentResults?.length > 0
              ? matchResultWithResponse()?.obtained_marks
              : score
          }
          onChange={(e) => {
            let value = e.target.value;
            if (/^\d*$/.test(value) || value === "") {
              const max = parseInt(response?.question?.correct_score) || 0;
              setInputValue((prev) => ({
                ...prev,
                score: value === "" || Number(value) <= max ? value : max,
              }));
            }
          }}
          onBlur={handleSubmitScore}
        />
      </Stack>

      {/* CORRECT ANSWER */}
      {response?.question?.correct_answers?.length > 0 && (
        <>
          <Divider sx={{ my: 3 }} />
          <Typography fontWeight={600} mb={1}>
            Correct Answer
          </Typography>

          {response.question.correct_answers.map((ans, index) => (
            <Box
              key={index}
              sx={{
                p: 2,
                borderRadius: 1.5,
                backgroundColor: "#f0fdf4",
                border: "1px solid #16a34a",
                mb: 1,
              }}
            >
              {ans?.reason_for_answer?.explanation}
            </Box>
          ))}
        </>
      )}
    </Paper>
  );
};

export default UploadQuestion;
